import { Cloudinary } from "@cloudinary/url-gen";
import { env } from "next-runtime-env";

import { CLOUDINARY_CONFIGURATION_ERROR } from "./error-utils";

export const cloudinary = function () {
  if (!env("NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME")) {
    throw CLOUDINARY_CONFIGURATION_ERROR;
  }

  return new Cloudinary({
    cloud: {
      cloudName: env("NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME"),
    },
  });
};
